
import React from 'react';
import { Box } from 'grommet';

class LegendPanel extends React.Component {

    componentDidMount() {
        if (!this.props.legend) {
            this.props.getLegend();
        }
    }

    getLegendHtmlContent() {
        let contentLayers = [];
        contentLayers.push(this.props.legend['header']);
        this.props.layers.forEach(item => {
            if (item.visible) {
                if (this.props.legend[item.id]) {
                    contentLayers.push(this.props.legend[item.id]);
                }
            }
        });
        contentLayers.push(this.props.legend['footer']);
        return contentLayers.join('');
    }

    render() {
        return (
            <Box
                flex="grow"
                height="600px"
                style={{
                    //overflow: 'hidden'
                }}
                dangerouslySetInnerHTML={{__html: this.getLegendHtmlContent()}}
            />
        );
    }
}

export default LegendPanel;
